import { gql } from '@apollo/client';

export const WorkOrderScopeFields = gql`
  fragment WorkOrderScopeFields on OdProtosHomeworkData_WorkOrderScope {
    id
    budgetAmountCents
    scheduledStartOn {
      year
      month
      day
    }
    scheduledStopOn {
      year
      month
      day
    }
    managerSignature {
      decision {
        ... on OdProtosHomeworkData_Signature_DecisionOneof_AcceptedBy {
          acceptedBy {
            userToken
          }
        }
      }
    }
    vendorSignature {
      decision {
        ... on OdProtosHomeworkData_Signature_DecisionOneof_AcceptedBy {
          acceptedBy {
            userToken
          }
        }
      }
    }
  }
`;
